import {
  ProductActions,
  OP_PRODUCT_LOAD,
  OP_PRODUCT_LOAD_COMPLETE,
  OP_PRODUCT_RESET,
  OP_PRODUCT_ADD_ENTITY,
} from '../../actions/products-actions/products.actions';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import { ProductOP } from '@cemex-core/cmx-api';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

/**
 * A state-object which describes the product options in the OT workflow
 */
export interface IProductsState {
  loaded: boolean;
  loading: boolean;
  topProducts: ProductOP[];
}

export const initialState: IProductsState = {
  loaded: false,
  loading: false,
  topProducts: [],
};

export function productsReducer(state = initialState, action: ProductActions | OrderBuilderActions): IProductsState {
  switch (action.type) {
    case OP_PRODUCT_LOAD: {
      return {
        ...state,
        loading: true,
        loaded: false,
      } as IProductsState;
    }
    case OP_PRODUCT_LOAD_COMPLETE: {
      const topProducts: ProductOP[] = action.payload.products;
      return {
        ...state,
        loaded: true,
        loading: false,
        topProducts: topProducts,
      } as IProductsState;
    }
    case OP_PRODUCT_ADD_ENTITY: {
      const selectedProductFromCatalog: IProduct = action.payload;
      const result = state.topProducts.find(product => product.productId === (_safe(() =>
        selectedProductFromCatalog.product.productId, selectedProductFromCatalog['productId'])));

      if (result === undefined) {
        const aux: ProductOP = {
          productCode: selectedProductFromCatalog['productCode'] || selectedProductFromCatalog.commercialCode,
          productDesc: selectedProductFromCatalog['productDesc'] || selectedProductFromCatalog.commercialDesc,
          productId: selectedProductFromCatalog['productId'] || selectedProductFromCatalog.product.productId,
        };

        if (selectedProductFromCatalog.unitOfMeasure) {
          aux.unit = {
            unitCode: '',
            unitDesc: '',
            unitId: selectedProductFromCatalog.unitOfMeasure.unitId,
            links: [],
          };
        }

        return {
          ...state,
          topProducts: [...state.topProducts, aux],
        };
      }
      return state;
    }
    case RESET_BUILDER:
    case OP_PRODUCT_RESET: {
      return {
        ...state,
        loading: false,
        loaded: false,
        topProducts: [],
      };
    }
    default: {
      return state;
    }
  }
}
